import React from 'react';
import { Link } from 'react-router-dom';

import {
  ButtonItemsContainer,
  ExpandedMenuContainer,
  MenuContent,
  MenuUserContainer,
  MenuSecondary,
  LogoutSpan,
  Icon
} from './ExpandedNavigationItems.styled';
import { ArrowRightFromBracket } from 'assets/icons/Icons';
import { pageUrl } from 'utilities/pageUrl';

import { ExpandedNavigationItemsProps } from './ExpandedNavigationItems.types';
import { MenuIcon } from '../MenuIcon/MenuIcon';
import { NavigationItems } from '../NavigationItems/NavigationItems';
import User from '../User/User';
import { UserProfileButton } from '../UserProfileButton/UserProfileButton';

export const ExpandedNavigationItems = ({
  toggleMenu,
  currentPathName,
  numberOfUnreadMessages,
  numberOfOutstandingInvoices,
  items,
  patient
}: ExpandedNavigationItemsProps) => {
  return (
    <ExpandedMenuContainer>
      <MenuContent>
        <MenuIcon toggleMenu={toggleMenu} isOpen={true} />
        <NavigationItems
          items={items}
          currentPathName={currentPathName}
          labelVisible={true}
          numberOfUnreadMessages={numberOfUnreadMessages}
          numberOfOutstandingInvoices={numberOfOutstandingInvoices}
        />
        <ButtonItemsContainer>
          <MenuSecondary>
            <Link to={pageUrl.logout()}>
              <Icon>
                <ArrowRightFromBracket type="solid" />
              </Icon>
              <LogoutSpan>Log out</LogoutSpan>
            </Link>
          </MenuSecondary>
          <MenuUserContainer>
            <UserProfileButton size={48} />
            <User patient={patient} />
          </MenuUserContainer>
        </ButtonItemsContainer>
      </MenuContent>
    </ExpandedMenuContainer>
  );
};
